module.exports = __webpack_public_path__ + "img/logo.cf485c85.png";